<template>
  <div>
    <el-card class="mb5">
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="8">
            <!-- 操作时间 -->
            <el-form-item :label="$t('GlobalSetObj.operationTime')">
              <el-date-picker
                v-model="queryForm.params.searchTime"
                type="datetimerange"
                range-separator="-"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                :default-time="['00:00:00', '23:59:59']"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                :end-placeholder="$t('GlobalSetObj.endDate')"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 设备名称 -->
            <el-form-item :label="$t('GlobalSetObj.deviceName')">
              <el-select
                  v-model="queryForm.params.deviceNumber"
                  :placeholder="$t('placeOrder.pleaseChoose')"
                  class="formTable"
                  clearable
                  filterable
                  style="width: 100%"
              >
                <el-option :label="$t('collectionCenter.tudo')" :value="null" />
                <el-option
                    v-for="item in deviceList"
                    :key="item.id"
                    :label="item.deviceName"
                    :value="item.deviceNumber"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 格口号 -->
            <el-form-item :label="$t('GlobalSetObj.GridSlogan')">
              <el-input v-model="queryForm.params.gridNumber" :placeholder="$t('placeOrder.pleaseInput')" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="">
              <template slot="label">
                <el-select v-model="numType" :placeholder="$t('GlobalSetObj.pleaseChoose')">
                  <!-- 安骏运单号 -->
                  <el-option :label="$t('orderCenterCont.anjunWaybillNumber')" value="waybillNumberList" />
                </el-select>
              </template>
              <InputTextareaCmp
                ref="inputTextareaRef"
                :max-length="2000"
                :val="listVal"
                @input="(_, val) => listVal = val"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!--查询-->
      <el-button
        type="primary"
        icon="el-icon-search"
        size="mini"
        @click="getTable"
      >{{ $t('basicData.Search') }}
      </el-button>
      <!--重置-->
      <el-button
        icon="el-icon-refresh"
        size="mini"
        @click="onReset"
      >{{ $t('basicData.reset') }}
      </el-button>
    </el-card>
    <el-card>
      <div class="mb10">
        <!-- 勾选导出 -->
        <el-button
          size="small" type="primary" @click="onExport(1)"
        >{{ $t('collectionCenter.export1') }}</el-button>
        <!-- 全部导出 -->
        <el-button
          size="small" type="primary" @click="onExport(2)"
        >{{ $t('collectionCenter.allExport') }}</el-button>
      </div>

      <el-table
        :data="tableData"
        border
        class="table-height"
        :height="tableHeightRow.height"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          fixed="left"
        />
        <el-table-column
          :label="$t('newOrder.SerialNumber')"
          align="center"
          type="index"
          width="80"
          fixed="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!-- 分拣机扫描单号 -->
        <el-table-column prop="scanNumber" :label="$t('GlobalSetObj.SortingMachineScanNumber')" min-width="180" />
        <!-- 安骏运单号 -->
        <el-table-column prop="waybillNumber" :label="$t('orderCenterCont.anjunWaybillNumber')" min-width="180" />
        <el-table-column
          v-for="(item, index) in cteColumns"
          :key="index"
          :label="item.label"
          :prop="item.prop"
          :min-width="item.minWidth"
          :label-class-name="item.headerIndex === null ? '' : item.headerIndex % 2 === 0 ? 'bg81d3f8' : 'bg8bcd98'"
        />
      </el-table>

      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentTable"
          @size-change="getSizeTable"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import InputTextareaCmp from '@/views/finance/cmp/Query/InputTextareaCmp.vue';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList.js';
import { deviceManagementList } from '@/api/automaticSorting';
import { getSortingRecordList, exportSortingRecord } from '@/api/storeAdmin';
const startTime = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59'; // 设置此刻的时间
export default {
  name: 'SortingMachineScanRecord',
  components: {
    InputTextareaCmp
  },
  mixins: [estimateTableHeight],
  data() {
    return {
      numType: 'waybillNumberList',
      listVal: '',
      deviceList: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          searchTime: [startTime, endTime],
          deviceNumber: null,
          gridNumber: ''
        }
      },
      pickerMinDate: '',
      pickerRange: 30 * 24 * 60 * 60 * 1000, // 可选择日期范围 为30天
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.pickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange));
          }
          return false;
        }
      },
      tableData: [],
      total: 0,
      cteColumns: [],
      multipleSelection: []
    };
  },
  mounted() {
    this.getDeviceTableList();
    for (let i = 0; i < 4; i++) {
      const headerScanTime = {
        label: i === 0 ? this.$t('GlobalSetObj.LatestScanTime') : this.$t('GlobalSetObj.HistoryScan') + '-' + i, // '最新扫描时间' - 历史扫描
        prop: i === 0 ? 'scanTime' : 'scanTime' + i,
        minWidth: 180,
        headerIndex: i === 0 ? null : i + 1
      };
      this.cteColumns.push(headerScanTime);
      const headerDeviceName = {
        label: this.$t('GlobalSetObj.deviceName'), // '设备名称',
        prop: i === 0 ? 'deviceName' : 'deviceName' + i,
        minWidth: 220,
        headerIndex: i === 0 ? null : i + 1
      };
      this.cteColumns.push(headerDeviceName);
      const headerGridNumber = {
        label: this.$t('GlobalSetObj.GridSlogan'), // '格口号',
        prop: i === 0 ? 'gridNumber' : 'gridNumber' + i,
        minWidth: 120,
        headerIndex: i === 0 ? null : i + 1
      };
      this.cteColumns.push(headerGridNumber);
    }
    this.$nextTick(() => {
      this.getTable();
    });
  },
  methods: {
    // 获取查询参数
    getQurey() {
      const inputVal = this.$refs.inputTextareaRef.getValue();
      const { numType } = this;
      const { searchTime, deviceNumber, gridNumber } = this.queryForm.params;
      const obj = {
        operateTimeStart: '',
        operateTimeEnd: '',
        waybillNumberList: [],
        deviceNumber,
        gridNumber
      };
      if (inputVal.length > 0) {
        obj[numType] = inputVal;
      }
      if (Array.isArray(searchTime) && searchTime.length === 2) {
        obj.operateTimeStart = searchTime[0];
        obj.operateTimeEnd = searchTime[1];
      }
      return obj;
    },
    // 获取列表数据
    getTable() {
      const { searchTime } = this.queryForm.params;
      if (!Array.isArray(searchTime) || searchTime.length < 2) {
        this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      const inputVal = this.$refs.inputTextareaRef.getValue();
      if (inputVal.length > 2000) {
        this.$message.warning(this.$t('orderCenterCont.queried2000pieces'));
        return;
      }
      const obj = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: this.getQurey()
      };
      getSortingRecordList(obj).then(res => {
        if (res.code === 200) {
          this.tableData = [];
          this.total = res.data.total;
          const sortingRecordData = res.data.records;
          // sortingRecordData.map(item => {
          //   if (item.scanInfoList && Array.isArray(item.scanInfoList)) {
          //     item.scanInfoList.sort((a, b) => {
          //       return new Date(b.scanTime) - new Date(a.scanTime);
          //     });
          //   }
          // });
          sortingRecordData.map(item => {
            const rowData = {
              id: item.id,
              waybillNumber: item.waybillNumber,
              scanNumber: item.scanNumber
            };
            item.scanInfoList.map((list, ind) => {
              rowData[ind === 0 ? 'scanTime' : 'scanTime' + ind] = list.scanTime;
              rowData[ind === 0 ? 'deviceName' : 'deviceName' + ind] = list.deviceName;
              rowData[ind === 0 ? 'gridNumber' : 'gridNumber' + ind] = list.gridNumber;
            });
            this.tableData.push(rowData);
          });
        }
      });
    },
    // 导出
    onExport(type) {
      const params = this.getQurey();
      if (type === 2) {
        if (this.tableData.length === 0) {
          this.$message.warning(this.$t('operationCenter.noDataExported'));
          return;
        }
      } else {
        if (this.multipleSelection.length === 0) {
          this.$message.warning(this.$t('operationCenter.PleaseTickTheDataExport'));
          return;
        } else {
          params.waybillNumberList = this.multipleSelection.map(item => item.waybillNumber);
        }
      }
      console.log(params, '===params');
      exportSortingRecord(params).then(() => {
        goResourceTaskList();
      }).catch(err => {
        console.error(err);
      });
    },
    // 勾选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 重置
    onReset() {
      this.queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          searchTime: [startTime, endTime],
          deviceNumber: null,
          gridNumber: ''
        }
      };
      this.numType = 'waybillNumberList';
      this.listVal = '';
      this.getTable();
    },
    // 获取设备列表
    getDeviceTableList() {
      deviceManagementList().then(res => {
        if (res.code === 200) {
          this.deviceList = res.data;
        }
      });
    },
    // 翻页
    getCurrentTable(val) {
      this.queryForm.pageNumber = val;
      this.getTable();
    },
    // 改变每页显示数量
    getSizeTable(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTable();
    }
  }
};
</script>

<style>
.bg81d3f8 {
  background: #81d3f8!important;
}
.bg8bcd98 {
  background: #8bcd98!important;
}
</style>
